/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdminDelegateDocumentRequest = {
  delegatee_email: string;
  delegatee_name: string;
  notification_preference?: AdminDelegateDocumentRequest.notification_preference;
  /**
   * Optional list of specific RequestedFile IDs to delegate. If not provided, delegates all files.
   */
  requested_file_ids?: Array<number>;
  /**
   * Optional list of specific Question IDs to delegate from the paired questionnaire.
   */
  question_ids?: Array<number>;
  /**
   * If true, skip delegating the paired questionnaire even if one exists.
   */
  skip_questionnaire?: boolean;
  /**
   * If true, skip delegating documents even if they exist.
   */
  skip_documents?: boolean;
};
export namespace AdminDelegateDocumentRequest {
  export enum notification_preference {
    EACH_UPLOAD = 'each_upload',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

